// Account Statements Payable Vuex

import state from './payableStatementStates.js'
import * as getters from './payableStatementGetters.js'
import * as mutations from './payableStatementMutations.js'
import * as actions from './payableStatementActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
